<template>
    <div class="hello">
      <el-dialog
        title="关联设备"
        :visible.sync="dialogVisible"
        width="1000px"
        :close-on-click-modal="false"
        :before-close="dialogClose"
      >
        <p class="store-name">{{storeName}}</p>
        <el-table
            border
            :header-cell-style="headerCellStyle"
            v-loading="loading"
            :cell-style="cellStyle"
            :data="tableData"
            max-height="700px"
            style="width: 100%">
            <el-table-column
                prop="device.deviceTypeName"
                label="设备类型"
                >
            </el-table-column>
            <el-table-column
                prop="device.deviceName"
                label="设备型号"
                >
                <template #default="{row}">
                    <div>{{row.device.deviceName}}</div>
                    <div v-if="row.device.isNoScan" class="isNoScan-tag">免扫码</div>
                </template>
            </el-table-column>
            <el-table-column
                prop="statusDes"
                min-width="150"
                label="设备状态">
                <template #default="{row}">
                    <div class="a-span" @click="goDeviceList(row)">
                        {{ row.statusDes }}
                    </div>
                    <div v-if="row.workinfo" class="run-time">
                        ({{row.workinfo?.predictEnd}})
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="statusTime"
                label="当前状态更新时间">
            </el-table-column>
            <el-table-column
                prop="lastStatusTime"
                label="上次状态更新时间">
            </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { Component, PropSync, Prop, Watch, Vue } from "vue-property-decorator";
  import { getDeviceLoadWithStatus } from "@/api/store";
  
  @Component
  export default class AssociatedDevice extends Vue {
    @PropSync("dialogVisible") visible;
    @Prop() storeId;
    @Prop() storeName;

    tableData = [];
    loading = false;

    goDeviceList(row) {
        console.log(row)
        const deviceCode = row.device.deviceCode;
        this.$router.push({
            path: "/device",
            query: {
                deviceCode: deviceCode
            }
        })
    }

    dialogClose() {
        this.visible = false;
    }

    // 表头样式
    headerCellStyle() {
        return {
        background: '#F8F9FA', color: '#1A1A1C', textAlign: 'center'
        }
    }
    // 列表样式
    cellStyle() {
        return {
        textAlign: 'center'
        }
    }

    @Watch("visible")
    getDeviceStatusList(value) {
        if (value) {
            this.loading = true;
            this.tableData = [];
            getDeviceLoadWithStatus({ storeId: this.storeId }).then((res) => {
                this.tableData = res.data;
                this.tableData?.forEach(item => {
                    item.device.deviceCode = item.device.deviceCode || item.device.deviceMessageCode;
                })
            }).finally(() => {
                this.loading = false;
            })
        }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .store-name{
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 10px;
  }
  .run-time{
    color: orange;
  }
  .isNoScan-tag {
  width: 60px; 
  display: inline-flex; 
  padding: 0 3px;
  background: #529DF1;
  border-radius: 5px;
  color: #FFFFFF;
  justify-content: center; 
  align-items: center; 
}
  </style>
  